__turbopack_context__.v({
  "picture": "QO7diW_picture",
});
